/*
 * Where each card of a brand collage goes. Shared by the home page hero
 * (src/components/home/brand-collage.js) and the share images
 * (src/lib/share-image/template.js) so both stack the same brands the same
 * way. CommonJS and tiny: it is bundled for the browser.
 *
 * A collage's slots are numbered the same in both places: see SLOT.
 */

const SLOT = {
  /** The largest card, in front. */
  CENTRE: 0,
  TOP_LEFT: 1,
  TOP_RIGHT: 2,
  BOTTOM_LEFT: 3,
  /** Bottom right, at the back: partly covered by the centre card and by FRONT. */
  BACK: 4,
  /** Small card at the bottom, in front of everything. */
  FRONT: 5,
  /** Small card at the top, behind its neighbours: suits a short, wide logo. */
  TOP_SMALL: 6,
};

/**
 * `items` in slot order. An item with `collageSlot` (set for the brands
 * data/featured-brands.js pins) takes that slot; the others fill the free
 * slots in the order given. A pinned slot the collage is too small to have
 * is ignored.
 *
 * @param {Array<{ collageSlot?: number }>} items
 * @param {number} size  Slots in the collage.
 */
const arrangeCollage = (items = [], size = 7) => {
  const picked = items.filter(Boolean).slice(0, size);
  const slots = new Array(picked.length).fill(null);
  const free = [];

  for (const item of picked) {
    const slot = item.collageSlot;

    if (Number.isInteger(slot) && slot >= 0 && slot < slots.length && !slots[slot]) {
      slots[slot] = item;
    } else {
      free.push(item);
    }
  }

  return slots.map((item) => item || free.shift());
};

module.exports = { SLOT, arrangeCollage };
